module.exports = __webpack_public_path__ + "static/media/27.24fb56c8.png";